import Link from "next/link";
import { Footer1Props } from "../../props";
import Image from "next/image";
import { SellerTypeEnum } from "@/components/package-components/types";

export default function FooterPerfilClickVariant(props: Footer1Props) {
  const sellerName = props.seller?.sellerName ?? "";
  const sellerDisplayName =
    sellerName.split(" ")[0].length > 2
      ? sellerName.split(" ")[0]
      : sellerName.trim();
  const sellerType = props.site?.sellerType ?? SellerTypeEnum.ONLY_USED;

  const isHybridSeller = sellerType === SellerTypeEnum.HYBRID;

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900">
      <div
        className={`pt-8 px-5 lg:px-0 ${
          isHybridSeller ? "pb-24 md:pb-2" : "pb-2"
        } max-w-[1024px] mx-auto`}
      >
        <div className="flex flex-col items-center gap-4 rounded-lg bg-amber-400 px-6 py-3 shadow-lg sm:flex-row sm:justify-between">
          <div className="max-w-[80%] text-black text-center sm:text-start">
            <strong className="text-xl font-pc">
              Faça como{" "}
              <strong className="font-pc">{sellerDisplayName},</strong> junte-se
              ao Perfil Click!{" "}
            </strong>
            <p className="text-[14px] sm:max-w-[70%] font-pc flex sm:text-nowrap flex-wrap">
              Obtenha seu próprio Perfil Click e maximize seu potencial de
              vendas.{" "}
              <Link
                className="hover:underline transition-all duration-200 font-pc w-full"
                href="https://www.youtube.com/watch?v=Gn_MabvxLdY"
                target="_blank"
                rel="noreferer"
              >
                <strong className="text-indigo-500 font-pc text-nowrap ml-[1.5px] mx-auto ">
                  Veja aqui como funciona.{" "}
                </strong>
              </Link>{" "}
            </p>
          </div>

          <Link
            className="inline-flex items-center gap-2 rounded border ring-[1.5px] ring-black bg-indigo-500 px-8 py-3  focus:ring-3 focus:outline-hidden transition-all duration-200 text-black shadow-[0.2em_0.2em] hover:shadow-[0.3em_0.3em] hover:-translate-x-[0.05em] hover:-translate-y-[0.05em] font-pc"
            href="https://perfil.click"
            target="_blank"
          >
            <span className="text-sm font-bold text-nowrap text-white font-pc">
              {" "}
              Saiba Mais{" "}
            </span>
          </Link>
        </div>

        <div>
          <div className="mt-8 sm:flex sm:items-center sm:justify-between">
            <div className="flex flex-col gap-5">
              <div className="flex justify-center items-center gap-3 sm:justify-start">
                <div
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    width: "stretch",
                  }}
                >
                  <Image
                    src={"https://perfil.click/images/LOGO_SVG.svg"}
                    width={36}
                    height={36}
                    alt="Perfil Click Logo"
                  />
                </div>
                <span className="text-xl text-white ">
                  <strong className="text-[1rem] font-pc">Perfil Click</strong>
                </span>
              </div>
            </div>

            <p className="mt-10 md:mt-0 text-sm text-white text-center sm:mt-0 sm:text-right text-nowrap font-pc">
              &copy; {currentYear} Desenvolvido por{" "}
              <Link
                className="hover:underline font-pc"
                href="https://sync.com.br"
              >
                {" "}
                sync
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
